import api from "../../api";

/**
 * Busca dados do relatório requisitado
 * @param reportType tipo de relatório a ser buscado
 */
export const getReport = async (reportType: string) => {
	const { data } = await api.get(`/manager/reports/`, {
		params: { type: reportType },
	});

	return data;
};
